import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import HamMenuIcon from "../../../../media/images/icons/hambergerMenu";

import TabItem from "./TabItem";
import DashboardIcon from "../../../../media/images/icons/dashboard";
import MedalIcon from "../../../../media/images/icons/medal-icon";
import GetLoadIcon from "../../../../media/images/icons/getLoadIcon";
import BoxOutlineIcon from "../../../../media/images/icons/outline-box";
import { useAppDispatch } from "../../../../hooks/useRedux";

import { setOpenDriverSidebar } from "../../../../redux/features/settingSlice";
import { useLocation } from "react-router-dom";

export default function BottomTabbar() {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);

  const { pathname } = useLocation();

  const dispatch = useAppDispatch();

  useEffect(() => {});

  const tabItems = [
    {
      icon: (
        <GetLoadIcon
          color={
            pathname === "/driver/get-freight"
              ? theme.palette.secondary.main
              : theme.palette.info.dark
          }
        />
      ),
      title: "دریافت‌بار",
      path: "/driver/get-freight",
    },
    {
      icon: (
        <DashboardIcon
          color={
            pathname === "/driver/dashboard"
              ? theme.palette.secondary.main
              : theme.palette.info.dark
          }
        />
      ),
      title: "پیشخوان",
      path: "/driver/dashboard",
    },
    {
      icon: (
        <BoxOutlineIcon
          color={
            pathname === "/driver/manage-freight"
              ? theme.palette.secondary.main
              : theme.palette.info.dark
          }
        />
      ),
      title: "مدیریت‌بارها",
      path: "/driver/manage-freight",
    },
    {
      icon: (
        <MedalIcon
          color={
            pathname === "/driver/karenclub"
              ? theme.palette.secondary.main
              : theme.palette.info.dark
          }
        />
      ),
      title: "کارن کلاب",
      path: "/driver/karenclub",
    },
  ];

  return (
    <Box
      sx={{
        zIndex: 2,
        bgcolor: "#ffffff",
        height: "60px",
        width: "100%",
        // border: "1px solid red",
        display: "flex",
        alignItems: "center",
      }}
    >
      <TabItem
        handleClick={() => dispatch(setOpenDriverSidebar(true))}
        icon={<HamMenuIcon size={18} color={theme.palette.info.dark} />}
        title={"منو"}
        path=""
      />
      {tabItems.map((item) => (
        <TabItem
          path={item.path}
          handleClick={(index) => setActiveTab(index)}
          icon={item.icon}
          title={item.title}
        />
      ))}
    </Box>
  );
}
